import React from "react";
import { PlusOutlined } from "@ant-design/icons";
import { PageWrapper } from "../../components/core/PageWrapper/PageWrapper";
import { AppRoutes, navigateToWithParams } from "../../domain/navigators/AppRoutes";
import { translate } from "../../domain/wiring/AppDomain";
import { HeaderActionBar, IActionButton } from "../home/headerbar/HeaderActionBar";
import styles from "../home/HomePageView.module.css";
import { SalesTransactionList } from "./list/SalesTransactionList";

interface IProps { }

export const SalesTransactionView = (props: IProps): JSX.Element => {
    return <PageWrapper className={styles.homePageView} pageHeaderTitle={translate("fp-home.title")}>
        <div>
            <SalesTransactionList />
        </div>
    </PageWrapper>;
};
